import { API_AUTH } from "./common";

const InLanDongLaiApi = {
  getInLanDongLai: ({ chovayId, isHienLaiGoc }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/in-danh-sach-dong-lai?chovayId=${chovayId}&isHienLaiGoc=${isHienLaiGoc}`,
      {}
    ),
};

export default InLanDongLaiApi;
